import algoliasearch from "algoliasearch/lite";

export const searchClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_PUBLIC_API_KEY,
);
